import React from "react";
import { ChevronUp } from "lucide-react";

export function BackToTop({ scrolled }) {
  if (!scrolled) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-8 right-8 z-40 w-12 h-12 rounded-full flex items-center justify-center transition-transform hover:-translate-y-1"
      style={{ background: "#1E9AFF", boxShadow: "0 10px 25px rgba(0,0,0,0.3)" }}
      aria-label="Back to top"
    >
      <ChevronUp color="#fff" />
    </button>
  );
}

export default BackToTop;
